import { configureStore } from "@reduxjs/toolkit";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { api } from "services/api";
import { logger } from "services/logger";
import reducer from "../features/combineReducer.js";

const persistConfig = {
  key: "root",
  storage,
  timeout: null,
  version: 1,
  whitelist: ["auth", "options", "admin", "flags", "locations", "oidc", "endVisit"],
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, reducer);
const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["payload.onFail", "payload.onSuccess"],
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: true,
    }).concat(logger, api),
  reducer: persistedReducer,
});
const persistor = persistStore(store);

// Export RootState type for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { persistor, store };
